/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
import PRM from "@/core/PermissionConstants";

export default {
  path: "/app/sincronizacion/camujal",
  name: "CAMUJAL",
  component: () => import("@/app/views/CamujalView.vue"),
  meta: {
    service: () => import("@/app/services/CamujalService.js"),
    tableSend: () => import("@/app/components/camujal/CamujalSendTable.vue"),
    tableSent: () => import("@/app/components/camujal/CamujalSentTable.vue"),
    historySendTable: () => import("@/app/components/camujal/historySend/historySendTable.vue"),
    historySendInfo: () => import("@/app/components/camujal/historySend/historySendInformation.vue"),
    summaryModal: () => import("@/app/components/camujal/historySend/SummarySendStudyModal.vue"),
    header: {
      icono: "mdi-clipboard-pulse-outline",
      texto: "Sincronización | Camujal",
    },
    prm: PRM.MODULE_CAMUJAL,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: false,
    filterModality: true,
    addButtonText: "Enviar estudio",
    labelDate: "Seleccione fecha"
  },
};
